// Import model
import { StartUserCreateFileRequest } from '../models/StartUserCreateFileRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartUserCreateFileRequest - handles JSON serialization and deserialization with type validation
 */
export class StartUserCreateFileRequestSerializer {
  /**
   * Deserializes a JSON string into a StartUserCreateFileRequest instance
   */
  static deserialize(json: string): StartUserCreateFileRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartUserCreateFileRequest instance
   */
  static fromObject(obj: any): StartUserCreateFileRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartUserCreateFileRequest');
    }


    const instance: StartUserCreateFileRequest = {
      fileName: obj['FileName'] as string | undefined,
      contentType: obj['ContentType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartUserCreateFileRequest instances
   */
  static deserializeArray(json: string): StartUserCreateFileRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartUserCreateFileRequest instance to a JSON string
   */
  static serialize(instance: StartUserCreateFileRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartUserCreateFileRequest instance to a plain object
   */
  static toObject(instance: StartUserCreateFileRequest): any {
    return {
      'FileName': instance.fileName,
      'ContentType': instance.contentType,
    };
  }

  /**
   * Serializes an array of StartUserCreateFileRequest instances to a JSON string
   */
  static serializeArray(instances: StartUserCreateFileRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
